import locationFarmImg from "@/assets/location-farm.png";
import { useScrollReveal } from "@/hooks/useScrollReveal";

export default function Location() {
  const ref = useScrollReveal();

  return (
    <section id="location" ref={ref} className="overflow-hidden" style={{ backgroundColor: "#F0EBE0" }}>

      {/* Full-width pause image */}
      <div className="img-reveal w-full relative overflow-hidden grain" style={{ height: "58vh" }}>
        <img
          alt="Rietkuil farm landscape with geese and morning sunbeams"
          className="w-full h-full object-cover object-center img-washed"
          src={locationFarmImg}
        />
        <div className="absolute inset-0" style={{ background: "rgba(30,22,8,0.28)" }}></div>
        <div className="absolute inset-0 flex items-center justify-center text-center px-6">
          <div>
            <p className="fade-in text-base tracking-[0.1em] uppercase font-sans font-medium mb-5" style={{ color: "rgba(255,255,255,0.9)" }}>Where to Find Us</p>
            <h2 className="fade-in delay-200 font-serif font-medium text-white leading-none" style={{ fontSize: "clamp(3rem, 6vw, 5.5rem)", textShadow: "0 1px 2px rgba(0,0,0,0.25), 0 0 40px rgba(0,0,0,0.15)" }}>
              Getting Here
            </h2>
          </div>
        </div>
      </div>

      {/* Info + map */}
      <div className="flex flex-col lg:flex-row">
        <div className="lg:w-[40%] flex items-center px-12 lg:px-20 py-20" style={{ backgroundColor: "#F0EBE0" }}>
          <div className="max-w-sm">
            <p className="fade-in font-sans font-light leading-loose text-sm mb-12" style={{ color: "#8C8478" }}>
              Rietkuil is tucked away in the Northern Free State near Bothaville — far enough from the city to feel like a real escape, but easy enough to reach for a weekend getaway.
            </p>
            <div className="space-y-8">
              {[
                { icon: "ri-map-pin-line", label: "Address", value: "Rietkuil Farm · Near Bothaville · Northern Free State, South Africa" },
                { icon: "ri-car-line", label: "By Car", value: "~2 hrs from Johannesburg · ~2 hrs from Bloemfontein" },
                { icon: "ri-road-map-line", label: "Directions", value: "Exact GPS coordinates and farm directions shared once your booking is confirmed." },
              ].map((item, i) => (
                <div key={item.label} className={`fade-in delay-${(i + 1) * 100} flex items-start gap-4`}>
                  <div className="w-7 h-7 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className={`${item.icon} text-sm`} style={{ color: "#87917C" }}></i>
                  </div>
                  <div>
                    <p className="text-sm uppercase tracking-[0.1em] mb-1 font-sans font-medium" style={{ color: "#7E7265" }}>{item.label}</p>
                    <p className="text-sm font-sans font-light leading-relaxed" style={{ color: "#6E5E40" }}>{item.value}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="lg:w-[60%] overflow-hidden" style={{ minHeight: "520px" }}>
          <iframe
            title="Rietkuil Farm Location — Near Bothaville, Free State"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d113000!2d26.6167!3d-27.3833!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1e9b3b3b3b3b3b3b%3A0x0!2sBothaville%2C%20Free%20State%2C%20South%20Africa!5e0!3m2!1sen!2sza!4v1700000000000!5m2!1sen!2sza"
            width="100%" height="100%"
            style={{ border: 0, minHeight: "520px", display: "block", filter: "saturate(0.6) brightness(1.05) sepia(0.1)" }}
            allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>

    </section>
  );
}
